import request from '@/utils/request';
export const getStatCountrysApi = (data)=>{
    return request({
        url: '/admin/stat/manufacturer/info',
        method: 'post',
        data
    })
}